export default __webpack_public_path__ + "310c3d6436fb297cfe585020d999fbfe.svg";